// 文件传输相关类型 — 用于 WebRTC 数据通道的元数据优先协议
// 简化自 LocalSend FileDto（去掉 sha256/preview/metadata 等可选字段以简化首版）

export type FileType = 'image' | 'video' | 'audio' | 'text' | 'application' | 'other';

// 文件元数据 — 在 FILE_LIST 消息中由发送方传给接收方
export interface FileDto {
  /** 文件 ID（发送方生成，UUID） */
  id: string;
  /** 文件名（含扩展名） */
  fileName: string;
  /** 文件大小（字节） */
  size: number;
  /** 文件类型分类 */
  fileType: FileType;
  /** MIME 类型（可选） */
  mimeType?: string;
}

// ===== 数据通道消息协议 =====
// 替换 LocalSend 的 nonce/token/cert 握手为简化的元数据优先协议

export type DataChannelMessage =
  // 发送方 → 接收方：发送文件清单
  | { type: 'FILE_LIST'; files: FileDto[] }
  // 接收方 → 发送方：确认接受部分/全部文件
  | { type: 'FILE_LIST_ACK'; selectedIds: string[] }
  // 接收方 → 发送方：拒绝接收
  | { type: 'DECLINE' }
  // 发送方 → 接收方：单个文件开始
  | { type: 'FILE_HEADER'; id: string }
  // 发送方 → 接收方：单个文件结束
  | { type: 'FILE_END'; id: string }
  // 接收方 → 发送方：单个文件确认
  | { type: 'FILE_ACK'; id: string; success: boolean; error?: string }
  // 发送方 → 接收方：全部传输结束
  | { type: 'END' }
  // 双向：取消传输
  | { type: 'CANCEL'; reason?: string };

// 文件分块大小（与 LocalSend webrtc.rs:CHUNK_SIZE 完全一致）
export const CHUNK_SIZE = 16 * 1024; // 16 KiB

// RTCDataChannel 背压水位
export const BUFFER_LOW_WATERMARK = 1 * 1024 * 1024; // 1 MiB
export const BUFFER_HIGH_WATERMARK = 4 * 1024 * 1024; // 4 MiB

// 文件传输状态机
export type TransferStatus =
  | 'idle'
  | 'connecting'
  | 'sdpExchanged'
  | 'connected'
  | 'transferring'
  | 'done'
  | 'declined'
  | 'canceled'
  | 'error';
